namespace $.$$ {
	$mol_style_define( $shm_knowledge, {
		Menu: { Head: { justifyContent: 'flex-start' }, Title: { flex: { grow: 0 } } },
	})
}
